<div class="spinnerdiv"  *ngIf="CSF.isLoading()" >
	<!-- " -->
	<!-- <div class="lds-facebook"><div></div><div></div><div></div></div> -->
	<div class="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>

               <!--  <div class="lds-ring"><div></div><div></div><div></div><div></div></div> -->
 <!--        <div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div> </div> -->
 				
</div>
<div class="spinnerdiv"  *ngIf="CSF.isLoading()" >
<h3 style="    color: black;
    text-align: center;
    position: absolute;
    top: 50%;
    z-index: 99;
    left: 48%;" *ngIf="CSF.isUploadingFile()" >{{CSF.percentUpload()}}%</h3>
</div>
<div>
<app-sidenav *ngIf="CSF.showNavsfun()"></app-sidenav>
<app-navbar *ngIf="CSF.showNavsfun()"></app-navbar>
<router-outlet></router-outlet>
</div>
